export default __webpack_public_path__ + "static/media/WhatsApp Community_Safeer.28337477.png";